import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'components/Accordion';
import RadioButton from 'components/DesignSystem/RadioButton';
import { CultureIndexPhenologicalStage } from 'types/Meteorology/Agro/CultureIndex/phenologicalStage';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import useStages from 'hooks/Meteorology/Agro/CultureIndex/Location/useStages';
import {
  selectMeteorologyAgroCultureIndexLocationCulture,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';

export default function PhenologicalStage() {
  const culture = useSelector(
    selectMeteorologyAgroCultureIndexLocationCulture,
  );

  const hasCulture = !!culture;

  // Hooks sempre chamados
  const { stages, selectedStage, setStage } = useStages();

  const closeAccordion = useMemo(
    () => buildAccordionClickFunction('culture-index-location-stage'),
    [],
  );

  const setStageAndClose = useCallback(
    (stage: CultureIndexPhenologicalStage) => {
      if (!hasCulture) {
        return;
      }

      setStage(stage);
      closeAccordion();
    },
    [setStage, closeAccordion, hasCulture],
  );

  return (
    <Accordion.Item eventKey="stage" id="culture-index-location-stage">
      <Accordion.Header>Estágio fenológico</Accordion.Header>
      <Accordion.Body>
        {
          hasCulture
          && stages.map((stage) => (
            <RadioButton
              className="my-2"
              key={stage.name}
              label={stage.label}
              checked={selectedStage?.name === stage.name}
              onChange={() => setStageAndClose(stage)}
            />
          ))
        }
      </Accordion.Body>
    </Accordion.Item>
  );
}
